import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            今日精选
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑团队每日精选热门好剧，帮你快速找到值得追的优质内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 3).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <span
                  className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-semibold whitespace-nowrap ${
                    card.tagColor === 'accent'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-primary-500 text-background-50'
                  }`}
                >
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{card.category}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </a>
          ))}

          {cardsData.slice(3).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all cursor-pointer sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).style.display = 'none';
                    }}
                  />
                  <span
                    className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-semibold whitespace-nowrap ${
                      card.tagColor === 'accent'
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-primary-500 text-background-50'
                    }`}
                  >
                    {card.tag}
                  </span>
                </div>
                <div className="flex-1 p-4 md:p-6 flex flex-col justify-center">
                  <h3 className="text-lg md:text-xl font-bold font-heading text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{card.category}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {card.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}